import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { ListColumn } from '../../../../app/interfaces/base/list-column';
import { IntegratedOptions } from '../../../../app/interfaces/base/integrated-options';

@Component({
  selector: 'fury-table-filters',
  templateUrl: './table-filters.component.html',
  styleUrls: ['./table-filters.component.scss']
})
export class TableFiltersComponent implements AfterViewInit, OnDestroy {

  @Input() options: ListColumn = null;
  @Input() data: IntegratedOptions[] = null;

  @Input() name: string = null;

  @Input() setValue: EventEmitter<any> = new EventEmitter();

  @Input() customFiltering: boolean = false;
  @Output() clearFilter: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() filterChange: EventEmitter<string | number> = new EventEmitter<string | number>();

  private destroy$: Subject<null> = new Subject<null>();

  constructor() {
  }

  ngAfterViewInit(): void {
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
